export function isHTMLInputElement(element) {
    if (!element) return false;

    // Moderne Browser
    if (typeof HTMLInputElement !== 'undefined') {
        return element instanceof HTMLInputElement;
    }

    // Fallback für ältere Browser
    return element &&
        element.nodeType === 1 &&
        element.tagName &&
        element.tagName.toLowerCase() === 'input';
}
